<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->


<template>
  <div id="page-application-create">

    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-1">Create an application</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <div class="vx-card p-4">
              <application-create-details ref="details" v-model="data"/>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col>
            <div class="vx-card p-4">
              <application-uri-details ref="uri" v-model="uriDetails"/>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button @click="cancel" class="my-4">Cancel</vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button @click="saveChanges" class="my-4" color="light">Create</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ApplicationCreateDetails from "@/views/pages/applications/create/ApplicationCreateDetails";
import ApplicationUriDetails from "@/views/pages/applications/edit/ApplicationUriDetails";
import FormValidateMixin from "@/components/mixins/FormValidateMixin";
import ApplicationValidation from "@/validation/Application";
ApplicationValidation.init();

export default {
  components: {
    ApplicationCreateDetails,
    ApplicationUriDetails,
  },
  mixins: [FormValidateMixin],
  data () {
    return {
      data: {
        ExternalIdentity: {},
      },
      uriDetails:{
        ExternalIdentity: {
          callbacks: [],
          allowed_origins: [],
          allowed_logout_urls: [],
          web_origins: [],
        }
      },
      forms: [
          'details',
          'uri'
      ]
    }
  },
  methods: {
    async saveChanges () {

      if (!await this.isValid()) {
        return;
      }

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
      const params = {
        ...this.data,
        ExternalIdentity: {
          ...this.data.ExternalIdentity,
          ...this.uriDetails.ExternalIdentity,
        }
      };

      params.ExternalIdentity.app_type = params.ExternalIdentity.app_type.value;

      delete params.applications;

      try {
        await this.$api.applications.create(params);
        this.$vs.notify({
          title: 'Application created',
          iconPack: 'feather',
          color: 'success',
          position: 'top-right'
        });
        await this.$router.push({name: 'application.list'}).catch(err => {});
      } catch (e) {

        this.addErrors(e);

        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to create application. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    cancel() {
      this.$router.push({name: 'application.list'});
    }
  },
}

</script>
